export enum TextItemPanels {
  NONE = 'none',
  CUSTOM_SHADOW = 'custom-shadow',
  FILL = 'fill',
  OUTLINE = 'outline',
  BACKGROUND_COLOR = 'background-color',
  FONT = 'font',
  LIST_COLOR = 'list_color',
  ANIMATION = 'animation',
}
